<div class="fetal_medicine header_top">
  <div class="banner">
    <div class="container">
      <h6>Fetal Therapy at NCare IVF, Kannur</h6>
      <h5>Giving Hope Before Birth</h5>
      <p>
        At NCare IVF, we offer advanced fetal therapy options to treat certain
        conditions affecting the baby during pregnancy. These minimally invasive
        procedures are performed while the baby is still in the womb, aiming to
        improve outcomes and reduce complications.
      </p>
      <p>
        All fetal interventions are performed by experienced fetal medicine
        specialists using the latest imaging and minimally invasive techniques.
        Our procedures are carried out in a dedicated fetal therapy suite
        equipped for complex care. We collaborate with specialists to ensure
        comprehensive, seamless care for both mother and baby.
      </p>
      <p>
        We follow international protocols and offer individualized treatment
        plans with one goal in mind: a safe and healthy outcome for your
        pregnancy.
      </p>
    </div>
  </div>
  <div class="fm_sec">
    <div class="container">
      <div class="accordion">
        <!-- 1. Amniocentesis -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="iut" checked />
          <label for="iut">1. Intrauterine Transfusion (IUT)</label>
          <div class="content">
            <p>
              <strong>What is Intrauterine Transfusion?</strong><br />
              Intrauterine transfusion (IUT) is a procedure where donor red
              blood cells are transfused into the baby to treat severe anemia,
              often caused by Rh incompatibility or infections like parvovirus
              B19.
            </p>

            <p>
              <strong>How is the blood transfused to the baby?</strong><br />
              A fine needle is inserted through the mother’s abdomen into the
              baby’s umbilical vein or abdominal cavity under ultrasound
              guidance.
            </p>

            <p>
              <strong>When is IUT recommended?</strong><br />
              IUT is recommended when the baby shows signs of severe anemia,
              such as changes in blood flow pattern as detected by Doppler scan
              and fluid accumulation in various organs of fetus on ultrasound
              examination.
            </p>

            <p>
              <strong>How many transfusions might be needed?</strong><br />
              Multiple transfusions may be required, usually every 2–3 weeks,
              until the baby reaches a safe gestational age for delivery.
            </p>

            <p>
              <strong>Is there any risk to the baby or mother?</strong><br />
              While any procedure carries some risk, IUT is generally safe and
              well-tolerated when done by specialists. However, there’s a small
              risk of premature labor or infection.
            </p>
          </div>
        </div>

        <!-- 2. CVS -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="rfa" />
          <label for="rfa">2. Radiofrequency Ablation (RFA)</label>
          <div class="content">
            <p>
              <strong>What is RFA used for in fetal treatment?</strong><br />
              RFA is used in complicated twin pregnancies (especially TRAP
              sequence or severe abnormalities in one twin) to safely stop blood
              flow to a non-viable or high-risk twin to protect the other.
            </p>

            <p>
              <strong>How does the procedure work?</strong><br />
              A needle with a radiofrequency probe is guided into the target
              twin, where it delivers heat to seal off the blood vessels
              supplying that fetus.
            </p>

            <p>
              <strong>How long does the procedure take?</strong><br />
              Typically around 30–60 minutes, depending on the case complexity
              and fetal position.
            </p>

            <p>
              <strong>Is RFA painful for the mother?</strong><br />
              The procedure is done under local anesthesia with sedation. Most
              mothers feel only mild discomfort and can return home the same
              day.
            </p>

            <p>
              <strong>What is the success rate?</strong><br />
              When performed appropriately, RFA has a good success rate in
              preserving the healthy twin’s life and reducing complications.
            </p>
          </div>
        </div>

        <!-- 3. Amnioreduction -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="bipolar_cord_coagulation" />
          <label for="bipolar_cord_coagulation"
            >3. Bipolar Cord Coagulation</label
          >
          <div class="content">
            <p>
              <strong>When is bipolar cord coagulation preferred?</strong><br />
              It’s preferred when laser therapy isn’t feasible (e.g.,
              unfavorable placental position) or in cases of severe fetal
              abnormalities where one twin’s survival threatens the other.
            </p>

            <p>
              <strong>What happens during the procedure?</strong><br />
              A fetoscope or needle is used to reach the umbilical cord, and
              bipolar forceps deliver electrical current to seal the vessels and
              stop blood flow.
            </p>

            <p>
              <strong>Why is it safer in certain cases?</strong><br />
              It gives greater control when laser treatment is difficult, and
              helps avoid emergency deliveries in high-risk pregnancies.
            </p>

            <p>
              <strong>Does the baby feel pain?</strong><br />
              No, the fetus does not feel pain during the procedure. The goal is
              to perform it as early and gently as possible to reduce stress on
              both mother and baby.
            </p>

            <p>
              <strong>How is the surviving twin monitored afterward?</strong
              ><br />
              Frequent ultrasounds and Doppler scans will be done to monitor
              growth, brain development, and overall health.
            </p>
          </div>
        </div>

        <!-- 4. Cordocentesis -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="laser_therapy" />
          <label for="laser_therapy"
            >4. Laser Therapy (Laser Photocoagulation)</label
          >
          <div class="content">
            <p>
              <strong>What is TTTS and how does laser therapy help?</strong
              ><br />
              TTTS (Twin-to-Twin Transfusion Syndrome) occurs when twins share a
              placenta and have unbalanced blood flow. Laser therapy seals off
              the shared vessels causing the problem, restoring balance.
            </p>

            <p>
              <strong>How is the procedure performed?</strong><br />
              A small camera (fetoscope) is inserted into the womb. Once the
              abnormal blood vessels are located, a laser is used to close them.
            </p>

            <p>
              <strong>What is the “Solomon technique”?</strong><br />
              This is a more advanced method where doctors also coagulate the
              area between the twins to prevent recurrence of TTTS or TAPS
              (anemia/polycythemia).
            </p>

            <p>
              <strong>When is the best time to do laser therapy?</strong><br />
              Usually between 16 and 26 weeks of pregnancy. Earlier intervention
              can help improve survival chances and long-term outcomes.
            </p>

            <p>
              <strong>What happens after the procedure?</strong><br />
              Most mothers are monitored in the hospital for a day or two.
              Follow-up scans are scheduled regularly to assess fetal
              well-being.
            </p>
          </div>
        </div>

        <!-- 5. Multifetal Reduction -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="multifetal" />
          <label for="multifetal">5. Fetal Shunt Procedures</label>
          <div class="content">
            <p>
              <strong>What is a fetal shunt and what does it treat?</strong
              ><br />
              A fetal shunt is a tiny tube inserted into the baby to drain
              excess fluid from organs like the bladder, lungs, or chest. It
              helps prevent damage to developing organs.
            </p>

            <p>
              <strong>Which conditions need shunt placement?</strong><br />
              Common indications include lower urinary tract obstructions
              (LUTO), pleural effusion, or congenital cystic adenomatoid
              malformation (CCAM).
            </p>

            <p>
              <strong>How is the shunt inserted?</strong><br />
              Under ultrasound guidance, a needle delivers a soft double-ended
              catheter (shunt) into the baby, creating a path for fluid to drain
              into the amniotic sac.
            </p>

            <p>
              <strong>What are the benefits of a shunt?</strong><br />
              It relieves pressure, helps lung development, and may improve
              kidney function and overall survival.
            </p>

            <p>
              <strong>Is shunting permanent?</strong><br />
              No. The shunt usually remains in place until birth or until the
              fluid re-accumulates. Some babies may still need postnatal
              surgery.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <h5>Need One of These Procedures? We’re Here to Help.</h5>
        <p>
          From life-saving fetal transfusions to advanced laser therapy, our
          specialists perform these procedures right here at NCare IVF Kannur,
          Kerala—safely, gently, and in the best interest of both mother and
          baby.
        </p>
        <button (click)="contactus()">Book an Appointment</button>
      </div>
    </div>
  </section>
  <!-- <div class="container">

        <div class="ncare-highlight">
            <h2>Expert Fetal Care You Can Trust</h2>
            <p>
                At NCare IVF Kannur, Kerala, our fetal therapy services are led by experienced maternal-fetal medicine
                specialists. Every procedure is personalized to the mother and baby’s specific needs, supported by
                real-time imaging, state-of-the-art technology, and compassionate care.

            </p>
            <p>

                If you have been advised fetal therapy or suspect complications during your pregnancy, our team is
                here to walk with you — every step of the way.
            </p>
        </div>
    </div> -->
</div>
